export type Game = {
  id: string,
  address: string;
  finished: boolean;
  player1: string;
  player1Name: string;
  player2: string;
  player2Name: string;
  winner: string;
  winnerName: string;
  betAmount: string;
};

export type GameReducerState = {
  loading: boolean;
  creatingGame: boolean;
  playingGames: Game["address"][];
  gameAddresses: string[];
  games: Record<string, Game>;
};

export const GAME_REDUCER_INITIAL_STATE: GameReducerState = {
  loading: false,
  creatingGame: false,
  playingGames: [],
  gameAddresses: [],
  games: {},
};
